// /brandkit/: copiar un color con un clic y el kit completo en markdown.
// El kit vive en /brandkit.md (public/), así la página y las IAs leen la misma fuente.

const toast = document.querySelector<HTMLElement>('[data-toast]')
let toastTimer: number | undefined

function say(msg: string): void {
  if (!toast) return
  toast.textContent = msg
  window.clearTimeout(toastTimer)
  toastTimer = window.setTimeout(() => { toast.textContent = '' }, 2600)
}

async function copy(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false // sin permiso de portapapeles o contexto no seguro
  }
}

document.querySelectorAll<HTMLButtonElement>('.bk-swatch[data-hex]').forEach((btn) => {
  btn.addEventListener('click', async () => {
    const hex = btn.dataset.hex ?? ''
    if (!(await copy(hex))) return
    btn.classList.add('is-copied')
    window.setTimeout(() => btn.classList.remove('is-copied'), 1400)
  })
})

document.querySelector<HTMLButtonElement>('[data-copy-kit]')?.addEventListener('click', async () => {
  try {
    const res = await fetch('/brandkit.md', { cache: 'no-cache' })
    if (!res.ok) throw new Error(String(res.status))
    // .text() decodifica UTF-8 siempre, aunque el servidor no declare charset
    const md = await res.text()
    say((await copy(md)) ? 'KIT COPIADO · PÉGALO EN TU IA O EN TU DOC' : 'NO SE PUDO COPIAR · ABRE EL .MD')
  } catch {
    say('NO SE PUDO COPIAR · ABRE EL .MD')
  }
})
